import FormattedMessage from 'I18n/components/FormattedMessage';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { H5 } from 'foundations-components/transitional/components/H5';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MeetingsNotYoursTooltip = ({
  meetingURL
}) => {
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(FormControl, {
      marginBlockEnd: "600",
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hubspot-prosemirror.meetings.linkTo"
      }),
      children: /*#__PURE__*/_jsx(TextInput, {
        readOnly: true,
        value: meetingURL
      })
    }), /*#__PURE__*/_jsx(H5, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hubspot-prosemirror.meetings.notMyMeetingsLinkPopover.title"
      })
    }), /*#__PURE__*/_jsxs(List, {
      styled: true,
      children: [/*#__PURE__*/_jsx(ListItem, {
        marginBlockEnd: "300",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "hubspot-prosemirror.meetings.notMyMeetingsLinkPopover.copiedTemplate"
        })
      }), /*#__PURE__*/_jsx(ListItem, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "hubspot-prosemirror.meetings.notMyMeetingsLinkPopover.deleteLink"
        })
      })]
    })]
  });
};
export default MeetingsNotYoursTooltip;